<template>
    <div class="p-grid data-table data-table-list">
        <div class="p-col-12">
            <div class="card card-w-title">
                <DataTable :value="purchases" class="p-datatable-responsive" :paginator="true" :rows="10" :filters="filters">
                    <template #header>
						<h2>List of purchases - {{$store.state.currentUser.surname}}</h2>
					</template>
                    <Column field="contract_id" header="Contract ID" :sortable="true">
                        <template #body="slotProps">
                            <span class="contract_id">{{ slotProps.data.id }}</span>
                        </template>
                    </Column>
					<Column field="package_name" header="Package" :sortable="true">
                        <template #body="slotProps">
                            <span class="name">{{ slotProps.data.package_name }}</span>
                        </template>
                    </Column>
					<Column field="time" header="Time of purchase" :sortable="true">
                        <template #body="slotProps">
                            <span class="time">{{ formatDate(slotProps.data.time) }}</span>
                        </template>
                    </Column>
                    <Column field="payment_type" header="Payment type" :sortable="true">
                        <template #body="slotProps">
                            <span class="payment_type">{{ slotProps.data.payment_type }}</span>
                        </template>
                    </Column>
					<Column field="status" header="Status" :sortable="true">
                        <template #body="slotProps">
                            <span class="status">{{ slotProps.data.status }}</span>
                        </template>
                    </Column>
                    <Column field="invoice" header="Invoice" :sortable="false">
                        <template #body="slotProps">
                            <a v-if="slotProps.data.status == 'approved'" :href="apiUrl + 'invoices/' + slotProps.data.id + '.pdf'" target="_blank">
                                <Button label="Invoice" class="btn-primary btn-open" icon="icon icon-open"/>
                            </a>
                        </template>
                    </Column>
                    <Column field="actions" header="Actions" :sortable="true">
                        <template #body="slotProps">
							<Button class="btn-primary" label="Details" @click="openDialog(slotProps.data)"/>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <Dialog :header="title" :visible.sync="display" :style="{width: '50vw'}" :modal="true">
            <div class="content-data">
                <h4>Purchase data</h4>
                <div class="data-item">
                    <p>Name</p>
                    <p>{{ activeRow.name }} {{ activeRow.surname }}</p>
                </div>
                <div class="data-item">
                    <p>Package</p>
                    <p>{{ activeRow.package_name }}</p>
                </div>
                <div class="data-item">
                    <p>Time of pruchase</p>
                    <p>{{ formatDate(activeRow.time) }}</p>
                </div>
                <div class="data-item">
                    <p>Status</p>
                    <p>{{ activeRow.status }}</p>
                </div>
                <div class="data-item">
                    <p>Payment type</p>
                    <p>{{ activeRow.payment_type }}</p>
                </div>
                <div class="data-item">
                    <p>Voucher</p>
                    <p>{{ activeRow.voucher_id }}</p>
                </div>
                <div class="data-item">
                    <p>Amount</p>
                    <p>{{ activeRow.amount }}</p>
                </div>
                <div class="data-item">
                    <p>Bank Account</p>
                    <p>{{ activeRow.bank_account }}</p>
                </div>
                <div class="data-item">
                    <p>BTC amount</p>
                    <p>{{ activeRow.btc_amount }}</p>
                </div>
                <div class="data-item">
                    <p>Wallet address</p>
                    <p>{{ activeRow.wallet_address }}</p>
                </div>
                <div class="data-item">
                    <p>Transaction Hash</p>
                    <p>{{ activeRow.transaction_hash }}</p>
                </div>
            </div>
        <template #footer>
            <div class="p-grid">
                <div class="p-md-6 p-offset-6">
                    <Button label="Close" @click="closeDialog()" icon="pi pi-times" class="p-button"/>
                </div>
            </div>
            </template>
        </Dialog>
    </div>
</template>

<script>

import PurchaseService from '../../service/PurchaseService';

export default {
    data() {
        return {
            purchases: [],
            editingCellRows: {},
            editingRows: [],
            filters: {},
            activeRow: {},
            display: false,
            title: '',
            message: 'Test message',
            apiUrl: process.env.VUE_APP_AUTH_URL,
            // columns: null
        }
    },
    created() {
        this.$store.commit('setPageTitle', {pageTitle: 'Purchases'});
        this.purchaseService = new PurchaseService();
        this.originalRows = {};
    },
    async mounted() {
        this.purchaseService.listMyPurchases(100).then(data => this.purchases = data);
        console.log(this.purchases);
        
    },
    methods: {
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                hours = "" + d.getHours(),
                mins = "" + d.getMinutes();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hours.length < 2) hours = "0" + hours;
            if (mins.length < 2) mins = "0" + mins;

            return [year, month, day].join("-") + " " + hours + ":" + mins;
        },
        openDialog(purchase) {
            this.display = true;
            this.activeRow = purchase
            this.title = 'Purchase data for package: ' + purchase.package_name
        } ,
        closeDialog() {
            this.display = false;
            this.documents = []
        }
    }
}

</script>

<style scoped>
</style>